export default "__VITE_ASSET__w1CwB2Nh__"